import * as z from "zod";

const PlacingBatchSchema_ = z.object({
  batchId: z.string(),
  title: z.string().nullable(),
  workOrderCount: z.number().int(),
  totalQuantity: z.number().int(),
});
export interface PlacingBatch extends z.infer<typeof PlacingBatchSchema_> {}

const PlacingToteGroupSchema_ = z.object({
  toteName: z.string(),
  toteId: z.string(),
  batches: z.array(PlacingBatchSchema_),
  totalWorkOrders: z.number().int(),
  totalQuantity: z.number().int(),
});
export interface PlacingToteGroup
  extends z.infer<typeof PlacingToteGroupSchema_> {}

export const getPlacingBatchesByTote = {
  name: "getPlacingBatchesByTote" as const,
  input: z.object({ stationId: z.string().optional() }),
  output: z.object({ toteGroups: z.array(PlacingToteGroupSchema_) }),
};
